<template>
    <div class="panel panel-default panel-dashboard">
        <div class="panel-body">
            <canvas width="800" height="250"/>

            <TheValueChartBreakdownModal :user="user" :month="month"/>
        </div>
    </div>
</template>

<script>
import Chart from 'chart.js'
import http from '@/http'
import datalabels from 'chartjs-plugin-datalabels'
import TheValueChartBreakdownModal from './TheValueChartBreakdownModal'

export default {
    components: {TheValueChartBreakdownModal},

    props: {
        user: {
            required: true,
            type: Object
        },

        year: {
            required: true,
            type: String
        }
    },

    data() {
        return {
            data: null,
            month: null,

            chart: null
        }
    },

    mounted() {
        this.load().then(this.draw)
    },

    watch: {
        year() {
            this.load().then(this.draw)
        }
    },

    computed: {
        dataPromise() {
            return http.post('/api/v1/reports/new-analytics', {
                metrics: [
                    {name: 'commission_value'}
                ],
                dimensions: [
                    {name: 'sold_month'},
                    {name: 'commissionable_type'}
                ],
                filters: [
                    {dimension: 'sold_month', operator: 'like', value: '%/' + this.year},
                    {dimension: 'user_id', operator: '=', value: this.user.id}
                ]
            })
        },

        months() {
            return [...Array(12).keys()]
                .map(i => i + 1)
                .map(i => i < 10 ? '0' + i : i)
                .map(i => i + '/' + this.year)
        },

        datasets() {
            return [
                this.getDataset('Total', [],'#8da3a6', 'line'),
                this.getDataset('Ads', ['publication-based-ads','time-based-ads'],'#16a34a'),
                this.getDataset('Subscriptions', ['subscription-periods'],'#20aaea'),
                this.getDataset('Adjustment', ['commission-items'],'#e8384f'),
            ]
        }
    },

    methods: {
        load() {
            return http.post('/api/v1/reports/new-analytics', {
                metrics: [
                    {name: 'commission_value'}
                ],
                dimensions: [
                    {name: 'sold_month'},
                    {name: 'commissionable_type'}
                ],
                filters: [
                    {dimension: 'sold_month', operator: 'like', value: '%/' + this.year},
                    {dimension: 'user_id', operator: '=', value: this.user.id}
                ]
            }).then(response => {
                this.data = response.data.data
            })
        },

        getDataset(label, dimensionValues, color, type = 'bar') {
            return {
                label,
                type,
                data: this.months.map(month => {
                    return this.data
                        .filter(row => row.sold_month === month && (dimensionValues.length === 0 || dimensionValues.includes(row.commissionable_type)))
                        .reduce((sum, row) => sum + row.commission_value, 0)
                }),
                backgroundColor: color,
                borderColor: color,
                fill: false
            }
        },

        draw() {
            if (this.chart) {
                this.chart.destroy()
            }

            this.chart = new Chart(this.$el.querySelector('canvas').getContext('2d'), {
                type: 'bar',

                data: {
                    labels: this.months,
                    datasets: this.datasets
                },

                options: {
                    scales: {
                        xAxes: [{
                            stacked: true
                        }],
                        yAxes: [{
                            stacked: true,
                            ticks: {
                                callback: label => this.$options.filters.price(label),
                                beginAtZero: true
                            }
                        }]
                    },

                    legend: {
                        position: 'bottom'
                    },

                    plugins: {
                        datalabels: {
                            display: false
                        }
                    },

                    tooltips: {
                        callbacks: {
                            label: (t, d) => d.datasets[t.datasetIndex].label + ': ' + this.$options.filters.price(d.datasets[t.datasetIndex].data[t.index])
                        }
                    },

                    onClick: (event, elements) => {
                        if (elements.length) {
                            this.month = this.months[elements[0]['_index']]

                            this.$nextTick(() => $('#value-chart-breakdown-modal').modal('show'))
                        }
                    }
                }
            })
        }
    }
}
</script>
